import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  h1: {
    textAlign: "center",
  },
  h4: {
    textAlign: "center",
    fontSize: 13,
  },
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 66,
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    color: "white",
  },
}));

export const Header = () => {
  const classes = useStyles();
  return (
    <Grid
      className={classes.root}
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <Typography
          variant="h4"
          component="h1"
          className={classes.h1}
          color="inherit"
        >
          {"elephant"}
        </Typography>
        <Typography
          variant="h4"
          component="h4"
          className={classes.h4}
          color="inherit"
        >
          {"Better for everyone"}
        </Typography>
      </Grid>
    </Grid>
  );
};
